import TtkHero from "@/sections/ttk/TtkHero";
import TtkBand from "@/sections/ttk/TtkBand";
import TtkApp from "@/sections/ttk/TtkApp";
import TtkTiles from "@/sections/ttk/TtkTiles";
import TtkTogether from "@/sections/ttk/TtkTogether";
import TwinButterfly from "@/components/TwinButterfly";
import SectionSnap from "@/components/SectionSnap";
import useMediaQuery from "@/hooks/useMediaQuery";

const SNAP_SELECTORS = [
  '[data-testid="ttk-hero-section"]',
  '[data-testid="ttk-app-simulator-section"]',
  '[data-testid="ttk-app-routine-section"]',
  '[data-testid="ttk-band-section"]',
  '[data-testid="ttk-tiles-section"]',
  '[data-testid="ttk-together-section"]',
];

const TTK_STOPS = [0, 0.16, 0.33, 0.5, 0.66, 0.83, 1];
const TTK_XS = ["10%", "80%", "12%", "88%", "10%", "86%", "78%"];
const TTK_YS = ["72%", "22%", "30%", "62%", "28%", "64%", "24%"];

const TransformationKit = () => {
  const snapEnabled = useMediaQuery("(min-width: 1024px) and (min-height: 620px)");
  return (
    <main data-testid="ttk-page" className="relative z-10">
      <TwinButterfly stops={TTK_STOPS} xs={TTK_XS} ys={TTK_YS} />
      <SectionSnap selectors={SNAP_SELECTORS} enabled={snapEnabled} />
      <TtkHero />
      <TtkApp />
      <TtkBand />
      <TtkTiles />
      <TtkTogether />
    </main>
  );
};

export default TransformationKit;
